module.exports = __webpack_public_path__ + "static/media/6.52697379.jpg";